import { Shape } from './part'
import { Vessel } from './vessel'
import { PartCatalog, partDef } from './catalog'

export interface Extents {
  /** estremo inferiore lungo Y nel sistema del veicolo */
  readonly minY: number
  readonly maxY: number
  /** distanza massima dall'asse Y */
  readonly maxRadius: number
  readonly height: number
}

export function shapeHalfHeight(shape: Shape): number {
  switch (shape.kind) {
    case 'cylinder': return shape.height / 2
    case 'cone': return shape.height / 2
    case 'box': return shape.y / 2
  }
}

export function shapeRadius(shape: Shape): number {
  switch (shape.kind) {
    case 'cylinder': return shape.radius
    case 'cone': return shape.radius
    case 'box': return Math.hypot(shape.x, shape.z) / 2
  }
}

/**
 * Ingombri del veicolo. Approssimazione volutamente grossolana: la parte e
 * trattata come una scatola allineata agli assi, senza tener conto della sua
 * rotazione. Serve a sapere dove appoggia il razzo sulla rampa e quanto
 * allontanare la camera, non a fare collisioni.
 */
export function vesselExtents(vessel: Vessel, catalog: PartCatalog): Extents {
  if (vessel.parts.length === 0) throw new Error('Veicolo senza parti: ingombri non definiti')

  let minY = Infinity
  let maxY = -Infinity
  let maxRadius = 0

  for (const p of vessel.parts) {
    const shape = partDef(catalog, p.defId).shape
    const h = shapeHalfHeight(shape)
    const r = shapeRadius(shape)
    minY = Math.min(minY, p.position.y - h)
    maxY = Math.max(maxY, p.position.y + h)
    maxRadius = Math.max(maxRadius, Math.hypot(p.position.x, p.position.z) + r)
  }

  return { minY, maxY, maxRadius, height: maxY - minY }
}
